export const customerTitle = {
  frs: 'Front Range Stone',
  trindco: 'Trindco',
  tcf: 'The Countertop Factory',
  simple: 'Simple Integrations',
  dev: 'DEV Simple Integrations'
};
